import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Icon, Dropdown, Popup, Button } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { auth } from '../index'

const paths = {
  '/products': 'Quotes',
  '/customers': 'Customers',
  '/materials': 'Saved Materials',
  '/standardOperations': 'Standard Operations',
}

class MainMenu extends Component {
  state = {}
  isCurrentPath(pathname) {
    return this.props.location.pathname === pathname
  }
  goTo(pathname) {
    this.props.history.push(pathname)
  }
  handleSignOut = () => {
    auth.signOut()
  }
  render() { 
    return (
      <Menu stackable inverted>
        <Menu.Item active={this.isCurrentPath('/')}><Link to='/'><Icon name='home' /> Home</Link></Menu.Item>
        <Dropdown item text={paths[this.props.location.pathname] || 'Go to'}>
          <Dropdown.Menu>
            {Object.keys(paths).map(key => (
              <Dropdown.Item key={key} onClick={() => this.goTo(key)}>{paths[key]}</Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        <Popup on='click'
          content={
            <Button color='orange' onClick={this.handleSignOut}>Sign Out</Button>
          }
          trigger={
            <Menu.Item position='right'>{auth.currentUser.email}</Menu.Item>
          }
        />
      </Menu>
    )
  }
}
 
export default withRouter(MainMenu);


// WEBPACK FOOTER //
// ./src/components/AppHeader.js